var React = require('react');

function BeigeLibra (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":".5302","y":"23.1746","width":"27.2861","height":"3.4641","fill":"#734f3e","strokeWidth":"0","key":0}),React.createElement("path",{"d":"M22.0831,15.1713c3.875-5.8623-1.0129-13.6403-7.91-13.4634-6.8956-.1779-11.7858,7.6035-7.9096,13.4634H.5302v3.4641h10.9505v-3.3163c-2.6189-1.2949-3.8861-4.2282-2.6245-6.9362.311-.6396.7747-1.2323,1.3309-1.737,2.1006-1.9545,5.8718-1.9563,7.9724,0,.5563.5047,1.0198,1.0973,1.3309,1.737,1.2617,2.7097-.0059,5.6407-2.6245,6.9362v3.3163h10.9505v-3.4641h-5.7333Z","fill":"#734f3e","strokeWidth":"0","key":1})]);
}

BeigeLibra.defaultProps = {"id":"Layer_1","data-name":"Layer 1","version":"1.1","viewBox":"0 0 28.3465 28.3465"};

module.exports = BeigeLibra;

BeigeLibra.default = BeigeLibra;
